<div class="card">
  <div class="card-header">
    <h4>Packers & Movers User Requirements</h4>
  </div>

  <div class="card-body">
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th>#</th>
          <th>Name</th>
          <th>Email</th>
          <th>Mobile</th>
          <th>Pickup Location</th>
          <th>Drop Location</th>
          <th>Moving Date</th>
          <th>Created At</th>
          <th>Actions</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let item of allRequirements; let i = index">
          <td>{{ (page - 1) * limit + i + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.mobile }}</td>
          <td>{{ item.pickupLocation }}</td>
          <td>{{ item.dropLocation }}</td>
          <td>{{ item.movingDate }}</td>
          <td>{{ item.createdAt | date: "dd-MM-yyyy hh:mm a" : "IST"  }}</td>
          <td>
            <button
              class="btn btn-info btn-sm"
              (click)="viewUserDetails(item._id)"
            >
              View Details
            </button>
          </td>
        </tr>

        <tr *ngIf="allRequirements.length === 0">
          <td colspan="8" class="text-center">No Records Found</td>
        </tr>
      </tbody>
    </table>

    <div class="mt-3">
      <button
        class="btn btn-primary"
        [disabled]="page === 1"
        (click)="changePage(page - 1)"
      >
        Previous
      </button>

      <span class="mx-3"> Page {{ page }} of {{ totalPages }} </span>

      <button
        class="btn btn-primary"
        [disabled]="page >= totalPages"
        (click)="changePage(page + 1)"
      >
        Next
      </button>
    </div>
  </div>
</div>
